export default __webpack_public_path__ + "static/media/ウォッカ.fc320842.PNG";